export default class Validator {
  constructor(validator, require) {
    this.validator = validator;
    this.require = !!require;
  }
}
